// extracted by mini-css-extract-plugin
export default {"templates":"templates__Dqj73f","saveButton":"saveButton__W8S2DL"};